import { useCampaignListingByType, ICampaignType } from '~/modules/campaign';

export const useCampaignTemplateListing = () => useCampaignListingByType(ICampaignType.TEMPLATE);
